import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=786a21d0&scoped=true&"
import script from "./problems.vue?vue&type=script&lang=js&"
export * from "./problems.vue?vue&type=script&lang=js&"
import style0 from "./problems.vue?vue&type=style&index=0&id=786a21d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a21d0",
  null
  
)

export default component.exports